import React from 'react';
import styles from 'signer-app/signature-modal/saved/saved-signature.module.css';
import classnames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  signatureAriaLabel: {
    id: '3b1247f5b0ba9ce066d5c6166153fe78a6bcbcb66f23f982c42d0ce34ce463f4',
    description: 'Screen reader label for the saved signature.',
    defaultMessage: 'Signature {index, number}',
  },
  deleteSignatureAriaLabel: {
    id: '11c7651377bfccccd3447301a97bce7a36b3ad16e3512e65b30d5bb4856eb471',
    description:
      'Screen reader label for an icon button to delete a saved signature.',
    defaultMessage: 'Delete signature {index, number}',
  },
});

interface SavedSignatureProps {
  index: number;
  signatureSrc: string;
}

const SavedSignature: React.FC<SavedSignatureProps> = ({
  index,
  signatureSrc,
}) => {
  const intl = useIntl();

  return (
    <div className={classnames(styles.savedSignature, styles.selected)}>
      <div className={styles.savedSignatureInner}>
        <div
          id={`saved-signature-${index}`}
          role="img"
          aria-label={intl.formatMessage(messages.signatureAriaLabel, {
            index,
          })}
          className={styles.savedSignatureImage}
          style={{
            backgroundImage: `url(${signatureSrc})`,
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(SavedSignature);
